export default __webpack_public_path__ + "static/media/046-calendar.3fb2bbfd.svg";